import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';
import {getLocationTypes} from '../../helpers/selectOptions';
import {locationTypeIsWithinDistance} from '../../helpers/scheduling';
import {
  useGetProviderAvailabilitiesQuery
} from '../../redux/services/providerAvailabilityApi';

const getFacilityOptions = ({config, maxDistance = 30}) => {
  if (!config?.locations || !config?.locations.length) return [];
  return config.locations
    .filter(f => f?.distance ? f.distance <= maxDistance : true)
    .map(f => ({
      label: f.name,
      value: `PARTNER_${f.id}`,
      emoji: '🏋️',
      dataType: 'facility',
      description: `${f.address_line_1}, ${f.address_city}`,
      colorName: 'primary',
      xs: 12,
      md: 12,
      lg: 12,
      xl: 12,
    }));
};

const getLocationTypeOptions = ({config, availability}) => {
  const anchorLocation = availability?.anchor_location;
  return getLocationTypes()
    .filter(lt => lt.value !== 'PARTNER')
    .filter(lt => (config?.location_types || []).includes(lt.value))
    .filter(lt => locationTypeIsWithinDistance({availability})(lt.value))
    .map(cat => ({
      label: cat.label,
      value: cat.value,
      // emoji: cat.emoji,
      description: cat.description,
      color: cat.colorName,
      xs: 12,
      md: 12,
      lg: 12,
      xl: 12,
    }));
};

const handleChange = ({onSubmit}) => (e, val) => {
  let serializedValue = {};
  const isLocation = /^PARTNER_/.test(val);
  if (isLocation) {
    const facilityId = val.replace(/^PARTNER_/, '');
    serializedValue.location_id = facilityId;
    serializedValue.location_type = 'PARTNER';
  } else {
    serializedValue.location_type = val;
    serializedValue.location_id = null;
  }
  onSubmit(e, serializedValue);
};

const PatientSchedulingLocationTypeForm = ({
  onSubmit,
  stepNum = 5,
  providerAvailabilityId,
  serviceCategory,
  location,
  allowScheduleManually = false,
  onScheduleManually = null,
  subtitle = 'Which location do you prefer for your session?',
}) => {
  console.log('PatientSchedulingLocationTypeForm.location', providerAvailabilityId, location);
  const filter = {id: providerAvailabilityId};
  if (location?.lat && location?.lon) {
    filter.calculate_distances = true;
    filter.lat = location.lat;
    filter.lon = location.lon;
  }
  const providerAvailabilityQuery = useGetProviderAvailabilitiesQuery(
    filter,
    {skip: !providerAvailabilityId}
  );
  const availability = providerAvailabilityQuery?.data?.data?.[0];
  const config = (availability?.configs || []).find(c =>
    serviceCategory &&
    c?.session_type?.service_category === serviceCategory
  );
  console.log('availability', providerAvailabilityId, availability, config);
  const options = [
    ...getLocationTypeOptions({config, availability}),
    ...getFacilityOptions({config, availability})
  ];
  return (
    <Stack spacing={1} alignItems='left'>
      <Typography variant='h2'>Preferred Location</Typography>
      <Typography>{subtitle}</Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          layout='row'
          options={options.map(o => ({...o}))}
          useColoredBackground={false}
          onChange={handleChange({onSubmit})}
        />
      </Box>
      {allowScheduleManually && !!onScheduleManually &&
        <Button
          variant='text'
          size='small'
          onClick={onScheduleManually}
        >
          Skip Scheduling for Now
        </Button>
      }
    </Stack>
  );
};

export default PatientSchedulingLocationTypeForm;